import { render, staticRenderFns } from "./businessGoods.vue?vue&type=template&id=00039d03&scoped=true"
import script from "./businessGoods.vue?vue&type=script&lang=js"
export * from "./businessGoods.vue?vue&type=script&lang=js"
import style0 from "./businessGoods.vue?vue&type=style&index=0&id=00039d03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00039d03",
  null
  
)

export default component.exports